import { Component, ContentChildren, QueryList, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RmsTabComponent } from '../rms-tab/rms-tab.component';

@Component({
  selector: 'rms-tab-group',
  templateUrl: './rms-tab-group.component.html',
  styleUrls: ['./rms-tab-group.component.scss'],
  imports: [CommonModule]
})
export class RmsTabGroupComponent implements AfterContentInit {
  @ContentChildren(RmsTabComponent) tabs!: QueryList<RmsTabComponent>;
  activeTabIndex = 0;
  @Output() tabSelected = new EventEmitter<string>();

  ngAfterContentInit() {
    const active = this.tabs.toArray().findIndex(tab => tab.active);
    this.activeTabIndex = active >= 0 ? active : 0;
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.tabSelected.emit(this.tabs.toArray()[index].label);
  }
}
